import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  AbortController21osa5gzjz756 as AbortController,
  readChunkwdrp33v51414 as readChunk,
  asByteArray2l3hscb95qi13 as asByteArray,
} from './Js.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { awaitxmqwgrq6yfmw as await_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { Builder1mo34du82b3c6 as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { HttpEngine345320iy1heif as HttpEngine } from './HttpEngine.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DefaultHttpEngine(timeoutMillis) {
  timeoutMillis = timeoutMillis === VOID ? 60000n : timeoutMillis;
  return JsHttpEngine().b6f(timeoutMillis);
}
var JsHttpEngineClass;
function JsHttpEngine() {
  if (JsHttpEngineClass === VOID) {
    class $ {
      constructor(connectTimeoutMillis, readTimeoutMillis) {
        return new.target.c6f(connectTimeoutMillis, readTimeoutMillis);
      }
      static c6f(connectTimeoutMillis, readTimeoutMillis) {
        var $this = createThis(this);
        $this.z6e_1 = connectTimeoutMillis;
        $this.a6f_1 = readTimeoutMillis;
        return $this;
      }
      static b6f(timeoutMillis) {
        return this.c6f(timeoutMillis, timeoutMillis);
      }
      *f68(request, $completion) {
        var abortController = AbortController();
        var connectTimeoutId = setTimeout(() => {
          abortController.abort();
          return Unit_instance;
        }, this.z6e_1);
        var fetchOptions = toFetchOptions(request, abortController.signal);
        var responsePromise = fetch(request.a4c_1, fetchOptions);
        var tmp;
        try {
          var response = yield* await_0(responsePromise, $completion);
          clearTimeout(connectTimeoutId);
          var responseBodySource = yield* readBody(response.body, this.a6f_1, abortController, $completion);
          // Inline function 'kotlin.apply' call
          var this_0 = (new (Builder())(response.status)).s4b(responseBodySource);
          var $this$apply = this_0;
          // Inline function 'kotlin.js.asDynamic' call
          response.headers.forEach((value, key) => $this$apply.b4b(key, value));
          tmp = this_0.v39();
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var t = $p;
            var tmp_1;
            if (t instanceof CancellationException()) {
              abortController.abort();
              throw t;
            } else {
              throw ApolloNetworkException().r49('Failed to execute GraphQL http network request', t);
            }
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      m6() {
      }
    }
    initMetadataForClass($, 'JsHttpEngine', VOID, VOID, [HttpEngine()], [1]);
    JsHttpEngineClass = $;
  }
  return JsHttpEngineClass;
}
function toFetchOptions(_this__u8e3s4, abortSignal) {
  var tmp;
  switch (_this__u8e3s4.z4b_1.w1_1) {
    case 0:
      tmp = 'GET';
      break;
    case 1:
      tmp = 'POST';
      break;
    case 2:
      tmp = 'QUERY';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var method = tmp;
  var headers = {};
  var _iterator__ex2g4s = _this__u8e3s4.b4c_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var header = _iterator__ex2g4s.r1();
    headers[header.l4b_1] = header.m4b_1;
  }
  var tmp1_safe_receiver = _this__u8e3s4.c4c_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    headers['Content-Type'] = tmp1_safe_receiver.g4a();
    // Inline function 'kotlin.takeIf' call
    var this_0 = tmp1_safe_receiver.h4a();
    var tmp_1;
    if (this_0 >= 0n) {
      tmp_1 = this_0;
    } else {
      tmp_1 = null;
    }
    var tmp0_safe_receiver = tmp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      headers['Content-Length'] = tmp0_safe_receiver.toString();
    }
    var bodyBuffer = new (Buffer())();
    tmp1_safe_receiver.i4a(bodyBuffer);
    tmp_0 = bodyBuffer.d3z();
  }
  var bodyBytes = tmp_0;
  // Inline function 'com.apollographql.apollo.network.http.dynamicObject' call
  var init = ($this$dynamicObject) => {
    $this$dynamicObject.signal = abortSignal;
    $this$dynamicObject.method = method;
    $this$dynamicObject.headers = headers;
    var tmp;
    if (!(bodyBytes == null)) {
      tmp = $this$dynamicObject.body = bodyBytes;
    }
    return Unit_instance;
  };
  var js = {};
  init(js);
  return js;
}
function *readBody(body, readTimeoutMillis, abortController, $completion) {
  var readTimeoutId = setTimeout(() => {
    abortController.abort();
    return Unit_instance;
  }, readTimeoutMillis);
  var bufferedSource = new (Buffer())();
  var tmp;
  if (body == null) {
    return new (Buffer())();
  } else {
    tmp = body;
  }
  var stream = tmp;
  var reader = stream.getReader();
  $l$loop: while (true) {
    try {
      var chunk = yield* readChunk(reader, $completion);
      clearTimeout(readTimeoutId);
      readTimeoutId = setTimeout(() => {
        abortController.abort();
        return Unit_instance;
      }, readTimeoutMillis);
      if (chunk == null) {
        break $l$loop;
      }
      bufferedSource.l3z(asByteArray(chunk));
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        reader.cancel(cause);
        throw cause;
      } else {
        throw $p;
      }
    }
  }
  clearTimeout(readTimeoutId);
  return bufferedSource;
}
//region block: exports
export {
  DefaultHttpEngine as DefaultHttpEngine26xguluicr03l,
};
//endregion

//# sourceMappingURL=DefaultHttpEngine.js.mjs.map
